if (!customElements.get('free-gift-item')) {  
  customElements.define("free-gift-item", class FreeGiftItem extends HTMLElement {
    constructor() {
      super();
      this.selectedProduct = null;
      this.currentVariant = null;
      this.gift_id = this.dataset.giftId;
      this.option_set = null;
    }

    connectedCallback() {
      this.productUpdatedEvent = new CustomEvent('coco-shuffle:product-updated', {});
      if (document.readyState === 'complete') {
        this.products = JSON.parse(this.dataset.products.replaceAll('%27', '&apos;').replaceAll('%22', '&quot;'));
        this.atcButton = this.querySelector('[data-action="add-to-cart"]');
        this.imageWrapper = this.querySelectorAll('[data-product-images]');
        this.displayOptions = this.querySelector('[data-display-options]');
        this.selectedProduct = this.products.find(({ id }) => id === this.dataset.initialProduct);
        this.option_set = [...this.querySelectorAll('select[data-select]')].map(select => select.value);
        this.currentVariant = this.selectedProduct.variants
          .find(({ options }) => options.every((x) => this.option_set.find((y) => y?.toLowerCase().trim() === x?.toLowerCase().trim())));
        this.clearInitialUnavailableIfMultiOption();
        this.addDelegatedEventListeners();
        return;
      }

      document.addEventListener('DOMContentLoaded', () => {
        this.products = JSON.parse(this.dataset.products.replaceAll('%27', '&apos;').replaceAll('%22', '&quot;'));
        this.atcButton = this.querySelector('[data-action="add-to-cart"]');
        this.imageWrapper = this.querySelectorAll('[data-product-images]');
        this.displayOptions = this.querySelector('[data-display-options]');
        this.selectedProduct = this.products.find(({ id }) => id === this.dataset.initialProduct);
        this.option_set = [...this.querySelectorAll('select[data-select]')].map(select => select.value);
        this.currentVariant = this.selectedProduct.variants
          .find(({ options }) => options.every((x) => this.option_set.find((y) => y?.toLowerCase().trim() === x?.toLowerCase().trim())));
        this.clearInitialUnavailableIfMultiOption();
        this.addDelegatedEventListeners();
      });
    }

    populateSelectedProductOptions() {
      if (!this.displayOptions || !this.selectedProduct) return;

      const productId = this.selectedProduct.id;

      const multipleOptionGroups = this.selectedProduct.options_with_values.length > 1;
      const optionsHTMLString = this.selectedProduct.options_with_values.map(({ name, values }) => {
        if (values.length < 1) return '';
        const nameHandle = name.toLowerCase().replace(/\s+/g, '-');
        return `
          <div data-option-group class="rounded-lg border border-transparent transition-colors duration-200 p-2 -m-2">
            <div class="flex items-center gap-1.5 mb-1">
              <strong class="text-xs uppercase">${name}:</strong>
              <strong data-option-label-${nameHandle} class="text-xs uppercase font-normal"></strong>
            </div>
            <ul class="flex flex-wrap gap-1">
              ${values.map((value) => {
                const available = multipleOptionGroups || this.selectedProduct.variants.find(({ available, options }) => available && options.includes(value));
                const valueHandle = value.toLowerCase().replace(/\s+/g, '-');
                return `
                  <li>
                    <div class="${available ? '' : 'unavailable '}group [&.unavailable]:opacity-50 rounded-[30px] flex items-center justify-center relative flex-shrink">
                      <input
                        data-action="option-choice"
                        data-option="${value}"
                        data-option-type="${name}"
                        id="gwp-option-${productId}-${valueHandle}"
                        type="radio"
                        class="absolute top-0 left-0 w-full h-full z-10 cursor-pointer opacity-0 peer"
                        value="${value}"
                        name="gwp-${name}-${productId}"
                        ${available ? '' : 'disabled'}
                      >
                      <span class="border duration-200 flex items-center justify-center max-h-8 py-1 pl-1.5 pr-3 rounded-[30px] text-primaryDark border-secondaryDark group-[.unavailable]:line-through transition-all z-1 peer-hover:text-primaryDark peer-enabled:peer-checked:text-primaryDark peer-checked:[&_.icon]:scale-100 peer-checked:[&_.icon]:opacity-100 peer-checked:gap-1.5 peer-checked:border-current peer-checked:bg-primaryLight peer-checked:pr-3.5">
                        <span aria-hidden="true" class="block h-1.5 w-1.5 scale-0 opacity-0 rounded-full bg-primaryDark transition-all duration-200 icon shrink-0"></span>
                        <label for="gwp-option-${productId}-${valueHandle}" class="block font-semibold text-xs cursor-pointer">${value}</label>
                      </span>
                    </div>
                  </li>
                `;
              }).join('')}
            </ul>
            <div data-selection-error class="hidden text-red-500 text-xs mt-1">Please select a ${name.toLowerCase()}.</div>
          </div>
        `;
      }).join('');

      this.displayOptions.innerHTML = optionsHTMLString;
      this.option_set = [];
      this.currentVariant = null;
      this.enabledOrDisableAddToCartButton();
    }
    
    addDelegatedEventListeners() {
      const select = this.querySelector('[data-select]');
      this.addSelectListener(select);

      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-action]');
        if (!clickedElement) return;
        
        const {
          action,
        } = clickedElement.dataset;
            
        let optionValue = null;
        if (clickedElement.closest('input[type="radio"]')) {
          optionValue = clickedElement.value;
        }
            
        switch (action) {
          case 'option-choice': {
            const optionVal = e.target.value;
            const optionTypeName = e.target.dataset.optionType;
            if (!optionVal || !this.selectedProduct || clickedElement.disabled) break;
            const optionIdx = this.selectedProduct.options_with_values
              .findIndex(({ values }) => values.find(v => v === optionVal));
            this.option_set = [...this.querySelectorAll('select[data-select], input[data-action="option-choice"]:checked')].map(el => el.value);
            if (optionIdx > -1) this.option_set[optionIdx] = optionVal;
            this.currentVariant = this.selectedProduct.variants
              .find(({ options }) => options.every((x) => this.option_set.find((y) => y?.toLowerCase().trim() === x?.toLowerCase().trim())));
            const optionHandle = optionTypeName?.toLowerCase().replace(/\s+/g, '-');
            const labelEl = this.querySelector(`[data-option-label-${optionHandle}]`);
            if (labelEl) labelEl.textContent = optionVal;
            const errorDiv = e.target.closest('div > ul')?.nextElementSibling;
            errorDiv?.classList.add('hidden');
            errorDiv?.closest('[data-option-group]')?.classList.remove('!border-red-500');
            this.updateOptionAvailability();
            this.enabledOrDisableAddToCartButton();
            break;
          }
          case 'add-to-cart': {
            if (window.isLoopActive?.()) break;
            const optionGroups = [...this.querySelectorAll('[data-display-options] [data-selection-error]')];
            let hasErrors = false;
            optionGroups.forEach(errorEl => {
              const ul = errorEl.previousElementSibling;
              const group = errorEl.closest('[data-option-group]');
              const checked = ul?.querySelector('input[type="radio"]:checked');
              if (!checked) {
                errorEl.classList.remove('hidden');
                group?.classList.add('!border-red-500');
                hasErrors = true;
              }
            });
            if (hasErrors) break;

            const minicart = document.querySelector('mini-cart');
            minicart?.classList.add('loading');

            const data = {
              sections: [`${document.querySelector('mini-cart')?.dataset.sectionId}`],
              items: [{
                id: this.currentVariant?.id,
                quantity: 1,
                properties: {
                  _free_gift: this.gift_id
                }
              }]
            };
            fetch('/cart/add.js', {
              body: JSON.stringify(data),
              credentials: 'same-origin',
              headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With':'xmlhttprequest'
              },
              method: 'POST'
            })
              .then((response) => {
                return response.json();
              })
              .then((json) => {
                if (window.matchMedia('(max-width: 768px)').matches) document.querySelector('drawer-modal [data-drawer-action="close"]')?.click();
                document.querySelector('quickbuy-modal')?.close();
                setTimeout(() => {
                  document.querySelector('mini-cart')?.updateCartHtml(json);
                  document.querySelector('mini-cart')?.open();
                }, window.matchMedia('(min-width: 768px)').matches ? 0 : 501);
              })
              .finally(() => {
                minicart?.classList.remove('loading');
              })
              .catch(function(err) {
                minicart?.classList.remove('loading');
                console.error(err);
              });
            break;
          }
          case 'next-slide':
            this.querySelector('swiper-carousel')?.slider.slideNext();
          break;
          case 'product-select': 
            const colorDisplay = this.querySelector('[data-display-color]');
            if (colorDisplay) colorDisplay.innerHTML = optionValue;
            this.selectedProduct = this.products.find((product) => product.color === optionValue.replaceAll(`'`, `&apos;`).replaceAll(`"`, `&quot;`));

            this.currentVariant = this.selectedProduct.variants
              .find(({ options }) => options.every((x) => this.option_set.find((y) => y?.toLowerCase().trim() === x?.toLowerCase().trim())));
            
            if (this.querySelector('[data-display-price]')) {
              this.querySelector('[data-display-price]').innerHTML = this.selectedProduct.price_money;
            }
              
            this.imageWrapper.forEach((el) => {
              el.innerHTML = '';
            });
            
            if (this.selectedProduct?.featured_image) {
              this.imageWrapper.forEach((el) => {
                el.href = this.selectedProduct.url;
                el.innerHTML += `
                  <img src="${this.selectedProduct.featured_image}" alt="${this.selectedProduct.featured_image_alt}" width="600" class="object-cover h-full w-full mix-blend-multiply" />
                `;
              });
            }
            
            this.enabledOrDisableAddToCartButton();
            this.populateSelectedProductOptions();
          break;
          default: break;
        }        
      });
    }

    addSelectListener(select) {
      if (!select) return;
      select.addEventListener('change', () => {
        this.option_set = [...this.querySelectorAll('select[data-select]')].map(select => select.value);
        this.currentVariant = this.selectedProduct.variants
              .find(({ options }) => options.every((x) => this.option_set.find((y) => y?.toLowerCase().trim() === x?.toLowerCase().trim())));

        this.enabledOrDisableAddToCartButton();
      });
    }
    
    clearInitialUnavailableIfMultiOption() {
      if (!this.selectedProduct || this.selectedProduct.options_with_values.length <= 1) return;
      this.querySelectorAll('input[data-action="option-choice"]').forEach(input => {
        input.closest('div')?.classList.remove('unavailable');
        input.removeAttribute('disabled');
      });
    }

    updateOptionAvailability() {
      if (!this.selectedProduct) return;
      const optionsWithValues = this.selectedProduct.options_with_values;

      optionsWithValues.forEach((_, groupIdx) => {
        const groupInputs = [...this.querySelectorAll('input[data-action="option-choice"]')]
          .filter(input => {
            const idx = optionsWithValues.findIndex(({ values }) => values.includes(input.value));
            return idx === groupIdx;
          });

        groupInputs.forEach(input => {
          const val = input.value;
          const available = this.selectedProduct.variants.some(variant => {
            if (!variant.available) return false;
            if (variant.options[groupIdx]?.toLowerCase().trim() !== val.toLowerCase().trim()) return false;
            return optionsWithValues.every((_, otherIdx) => {
              if (otherIdx === groupIdx) return true;
              const selected = this.option_set[otherIdx];
              if (!selected) return true;
              return variant.options[otherIdx]?.toLowerCase().trim() === selected.toLowerCase().trim();
            });
          });

          const wrapper = input.closest('div');
          if (available) {
            wrapper?.classList.remove('unavailable');
            input.removeAttribute('disabled');
          } else {
            wrapper?.classList.add('unavailable');
            input.setAttribute('disabled', 'true');
          }
        });
      });
    }

    enabledOrDisableAddToCartButton() {
      if (!this.atcButton) return;

      const optionGroups = [...this.querySelectorAll('[data-display-options] [data-selection-error]')];
      const allSelected = optionGroups.length === 0 || optionGroups.every(errorEl => {
        const ul = errorEl.previousElementSibling;
        return ul?.querySelector('input[type="radio"]:checked');
      });

      if (!allSelected) {
        this.atcButton.textContent = 'Select Size & Color';
        this.atcButton.className = 'button-md w-full mt-4 h-11 flex items-center justify-center text-base font-semibold rounded-lg bg-primaryDarkScale-600 text-primaryLight cursor-pointer';
        return;
      }

      this.atcButton.textContent = 'Add Gift to Cart';
      this.atcButton.className = 'button-md button-primary w-full mt-4 h-11 flex items-center justify-center text-base font-semibold';

      if (!this.currentVariant?.available) {
        this.atcButton.setAttribute('disabled', 'true');
      } else {
        this.atcButton.removeAttribute('disabled');
      }
    }
  });
}